import React from 'react';
import { BaseConfigProps } from '../shared/ConfigFormHelpers';

const MissingItemsQueryConfig: React.FC<BaseConfigProps> = ({ node, updateConfig }) => {
  const config = node.data.config || {};
  const statusFilter = config?.statusFilter || 'all';
  const includeCompleted = config?.includeCompleted || false;
  const sortBy = config?.sortBy || 'createdAt';
  const groupByCustomer = config?.groupByCustomer || false;

  const handleChange = (field: string, value: any) => {
    updateConfig(field, value);
  };

  return (
    <div className="space-y-4">
      <div className="bg-orange-50 dark:bg-orange-900/20 border border-orange-200 dark:border-orange-800 rounded-lg p-3">
        <h4 className="text-sm font-medium text-orange-900 dark:text-orange-100 mb-2">
          📦 Hiányzó tételek lekérdezése
        </h4>
        <p className="text-xs text-orange-700 dark:text-orange-300">
          Lekérdezi a hiányzó tételeket a rendszerből különböző szűrési feltételekkel.
        </p>
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          Státusz szűrés
        </label>
        <select
          value={statusFilter}
          onChange={(e) => handleChange('statusFilter', e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-orange-500 dark:bg-gray-700 dark:text-gray-100"
        >
          <option value="all">Összes</option>
          <option value="pending">Függőben</option>
          <option value="in_progress">Folyamatban</option>
          <option value="ordered">Megrendelve</option>
          <option value="completed">Teljesítve</option>
        </select>
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          Rendezés
        </label>
        <select
          value={sortBy}
          onChange={(e) => handleChange('sortBy', e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-orange-500 dark:bg-gray-700 dark:text-gray-100"
        >
          <option value="createdAt">Létrehozás dátuma</option>
          <option value="updatedAt">Módosítás dátuma</option>
          <option value="itemName">Tétel neve</option>
          <option value="quantity">Mennyiség</option>
        </select>
      </div>

      <div className="space-y-2">
        <div className="flex items-center">
          <input
            type="checkbox"
            id="includeCompleted"
            checked={includeCompleted}
            onChange={(e) => handleChange('includeCompleted', e.target.checked)}
            className="h-4 w-4 text-orange-600 focus:ring-orange-500 border-gray-300 rounded"
          />
          <label htmlFor="includeCompleted" className="ml-2 block text-sm text-gray-700 dark:text-gray-300">
            Teljesített tételek is
          </label>
        </div>

        <div className="flex items-center">
          <input
            type="checkbox"
            id="groupByCustomer"
            checked={groupByCustomer}
            onChange={(e) => handleChange('groupByCustomer', e.target.checked)}
            className="h-4 w-4 text-orange-600 focus:ring-orange-500 border-gray-300 rounded"
          />
          <label htmlFor="groupByCustomer" className="ml-2 block text-sm text-gray-700 dark:text-gray-300">
            ✨ Csoportosítás ügyfél szerint (visszaadja az érintett ügyfeleket is)
          </label>
        </div>
      </div>

      <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg p-3">
        <h4 className="text-sm font-medium text-blue-900 dark:text-blue-100 mb-2">
          📥 Bemenet (Input)
        </h4>
        <div className="space-y-1">
          <div className="flex items-start space-x-2">
            <span className="text-xs font-mono bg-white dark:bg-gray-800 px-2 py-0.5 rounded border border-blue-200 dark:border-blue-700">trigger</span>
            <span className="text-xs text-blue-700 dark:text-blue-300">Opcionális - Trigger esemény</span>
          </div>
        </div>
      </div>

      <div className="bg-orange-50 dark:bg-orange-900/20 border border-orange-200 dark:border-orange-800 rounded-lg p-3">
        <h4 className="text-sm font-medium text-orange-900 dark:text-orange-100 mb-2">
          📤 Kimenet (Output)
        </h4>
        <div className="space-y-2">
          <div className="flex items-start space-x-2">
            <span className="text-xs font-mono bg-white dark:bg-gray-800 px-2 py-0.5 rounded border border-orange-200 dark:border-orange-700">missingItems</span>
            <span className="text-xs text-orange-700 dark:text-orange-300">Array - Hiányzó tételek listája</span>
          </div>
          <pre className="text-xs bg-white dark:bg-gray-800 p-2 rounded border border-orange-200 dark:border-orange-700 overflow-x-auto">
{`{
  "missingItems": [
    {
      "id": "item123",
      "itemName": "Alkatrész XYZ",
      "quantity": 5,
      "unit": "db",
      "status": "pending",
      "customer": {...},
      "createdAt": "2025-10-28T12:00:00Z"
    }
  ],
  "count": 10
}`}
          </pre>
        </div>
      </div>

      <div className="bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-200 dark:border-yellow-800 rounded-lg p-3">
        <h4 className="text-sm font-medium text-yellow-900 dark:text-yellow-100 mb-1">
          💡 Használat
        </h4>
        <p className="text-xs text-yellow-700 dark:text-yellow-300">
          Kösd össze egy Loop node-dal, hogy minden hiányzó tételre végrehajts valamit (pl. értesítés küldés).
        </p>
      </div>
    </div>
  );
};

export default MissingItemsQueryConfig;
